import { breakpoints, spacing } from '@naf/theme';
import { Text } from '@naf/text';
import styled, { css } from 'styled-components';

export const ChartWrapper = styled.figure<{ $asTable?: boolean }>`
  margin: 0;
  ${({ $asTable }) =>
    $asTable
      ? css`
          margin-top: 18px !important;
          @media (max-width: ${breakpoints.m}) {
            overflow-x: auto;
          }
        `
      : null};
  width: 100%;
`;

export const Heading = styled(Text)<{ $asTable?: boolean }>`
  margin: 0 0 ${({ $asTable }) => ($asTable ? `${spacing.space24} !important` : spacing.space4)};
`;

export const Ingress = styled(Text)<{ $asTable?: boolean }>`
  margin: 0 0 ${({ $asTable }) => ($asTable ? `${spacing.space32} !important` : spacing.space4)};
`;

export const Caption = styled(Text)<{ $asTable?: boolean }>`
  font-style: italic;
  margin-top: ${({ $asTable }) => ($asTable ? `${spacing.space32} !important` : '0')};
  margin-bottom: 0;
`;
